import { exchangeKornitStationToken } from "../api/kornit";

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);

/**
 * A Kornit connector can open the machine screen on another shop's domain
 * (older installs default to app.bespokethreads.com). The ?t= station token
 * names the real shop, so move to its web address before the login gate runs.
 * Resolves true when the page is navigating away.
 */
export async function redirectStationToTenantHost({ timeoutMs = 4000 } = {}) {
  if (typeof window === "undefined") return false;
  const { pathname, search, hostname } = window.location;
  if (!pathname.startsWith("/machines") || LOCAL_HOSTS.has(hostname)) {
    return false;
  }
  const token = new URLSearchParams(search).get("t");
  if (!token) return false;

  try {
    const res = await Promise.race([
      exchangeKornitStationToken(token),
      new Promise((resolve) => setTimeout(() => resolve(null), timeoutMs)),
    ]);
    const appUrl = (res?.data || res)?.appUrl;
    if (!appUrl) return false;
    const target = new URL(appUrl);
    if (target.protocol !== "https:" || target.hostname === hostname) {
      return false;
    }
    window.location.replace(`${target.origin}${pathname}${search}`);
    return true;
  } catch {
    return false;
  }
}
